import { useEffect, useState } from "react";
import MarketingShell from "@/components/marketing/MarketingShell";
import OfferLadder from "@/components/marketing/OfferLadder";
import { http } from "@/lib/api";
import { useSeo } from "@/lib/seo";

export default function Pricing() {
  const [products, setProducts] = useState([]);
  useSeo({ title: "Private Infant Sleep Consulting Pricing | $99 to $2,549", description: "Transparent pricing for optional private infant sleep consulting: the $99 Diagnostic, $279 Blueprint, $749 Guided Virtual Consulting, and $2,549 In-Home + Overnight. No discounted upgrades, no credits.", canonical: "/pricing" });
  useEffect(() => { http.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  return (
    <MarketingShell>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-10">
        <div className="eyebrow text-[#C2836B] mb-4">Private Consulting · Separate &amp; Optional</div>
        <h1 className="font-display text-4xl sm:text-5xl text-[#F7F5F0] tracking-tight max-w-2xl">Private infant sleep consulting</h1>
        <p className="text-[#A39E98] mt-5 max-w-2xl text-[17px]">Individual consulting services for families who want a personal review of their baby's sleep. These services are separate from our courses: they are not included in course tuition and are never required to enroll in or complete any course. Each service is complete on its own.</p>
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-16">
        <OfferLadder products={products} />
      </section>
    </MarketingShell>
  );
}
